import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';

import CarouselImg from '../images/Carousel.jpg';
import Carousel1Img from '../images/Carousel1.jpg';
import Carousel4Img from '../images/Carousel4.jpg';
import Carousel5Img from '../images/Carousel5.jpg';
import Carousel6Img from '../images/Carousel6.jpg';

const slides = [
  {
    image: CarouselImg,
    alt: 'Spur Ventures event',
  },
  {
    image: Carousel1Img,
    alt: 'Spur Ventures conference gathering',
  },
  {
    image: Carousel4Img,
    alt: 'Agricultural innovation event',
  },
  {
    image: Carousel5Img,
    alt: 'AgTech networking event',
  },
  {
    image: Carousel6Img,
    alt: 'Spur Ventures community event',
  },
];

const AUTO_ADVANCE_TIME = 5500;

const PhotoCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const changeSlide = useCallback((slideIndex) => {
    const normalizedIndex =
      (slideIndex + slides.length) % slides.length;

    setCurrentSlide(normalizedIndex);
  }, []);

  useEffect(() => {
    if (isPaused) {
      return undefined;
    }

    const interval = window.setInterval(() => {
      setCurrentSlide((previousSlide) =>
        previousSlide === slides.length - 1
          ? 0
          : previousSlide + 1
      );
    }, AUTO_ADVANCE_TIME);

    return () => {
      window.clearInterval(interval);
    };
  }, [isPaused]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      changeSlide(currentSlide - 1);
    }

    if (event.key === 'ArrowRight') {
      changeSlide(currentSlide + 1);
    }
  };

  return (
    <div
      className="sg-carousel"
      role="region"
      aria-label="Spur Ventures photo gallery"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocus={() => setIsPaused(true)}
      onBlur={() => setIsPaused(false)}
    >
      <div className="sg-carousel-frame">
        <div
          className="sg-carousel-track"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              className="sg-slide"
              key={slide.image}
              aria-hidden={index !== currentSlide}
            >
              <img
                className="sg-slide-image"
                src={slide.image}
                alt={slide.alt}
                loading={index === 0 ? 'eager' : 'lazy'}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="sg-control-bar">
        <div
          className="sg-progress-list"
          aria-label="Choose a gallery image"
        >
          {slides.map((slide, index) => (
            <button
              type="button"
              key={slide.image}
              className={`sg-progress-button ${index === currentSlide ? 'active' : ''
                }`}
              onClick={() => changeSlide(index)}
              aria-label={`Show gallery image ${index + 1}`}
              aria-current={
                index === currentSlide ? 'true' : undefined
              }
            >
              <span className="sg-progress-number">
                {String(index + 1).padStart(2, '0')}
              </span>

              <span className="sg-progress-line" />
            </button>
          ))}
        </div>

        <div className="sg-arrow-group">
          <button
            type="button"
            className="sg-arrow"
            onClick={() => changeSlide(currentSlide - 1)}
            aria-label="Show previous image"
          >
            <i className="fas fa-arrow-left" />
          </button>

          <button
            type="button"
            className="sg-arrow"
            onClick={() => changeSlide(currentSlide + 1)}
            aria-label="Show next image"
          >
            <i className="fas fa-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoCarousel;